var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIconShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8475 11.5331C23.6331 11.2398 18.5245 4.35156 11.9999 4.35156C5.47529 4.35156 0.366469 11.2398 0.152297 11.5328C-0.0507657 11.8111 -0.0507657 12.1885 0.152297 12.4667C0.366469 12.76 5.47529 19.6483 11.9999 19.6483C18.5245 19.6483 23.6331 12.76 23.8475 12.467C24.0508 12.1888 24.0508 11.8111 23.8475 11.5331ZM11.9999 18.0659C7.19383 18.0659 3.03127 13.494 1.79907 11.9994C3.02968 10.5035 7.18351 5.93397 11.9999 5.93397C16.8057 5.93397 20.968 10.505 22.2007 12.0005C20.9701 13.4963 16.8163 18.0659 11.9999 18.0659Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.25195C9.3823 7.25195 7.25262 9.38163 7.25262 11.9992C7.25262 14.6168 9.3823 16.7465 11.9999 16.7465C14.6175 16.7465 16.7472 14.6168 16.7472 11.9992C16.7472 9.38163 14.6175 7.25195 11.9999 7.25195ZM11.9999 15.164C10.2547 15.164 8.83508 13.7443 8.83508 11.9992C8.83508 10.2541 10.2548 8.83441 11.9999 8.83441C13.745 8.83441 15.1647 10.2541 15.1647 11.9992C15.1647 13.7443 13.7451 15.164 11.9999 15.164Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIconShow);
export default __webpack_public_path__ + "static/media/password_icon_show.35d85cbe5fa2928347e568c5b201fb5d.svg";
export { ForwardRef as ReactComponent };